
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(07|12|23|64|8)|215|944)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
